import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'

const P = '/mang-xa-hoi'

// Thích bài viết
export function thichBaiViet(postId: number, params: any) {
  try {
    return axiosApi.post(`${P}/bai-dang/${postId}/phan-hoi`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Bỏ thích bài viết
export function boThichBaiViet(postId: number) {
  try {
    return axiosApi.delete(`${P}/bai-dang/${postId}/phan-hoi`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy cảm xúc bài viết
export function layCamXucBaiViet(postId: number) {
  try {
    return axiosApi.get(`${P}/bai-dang/${postId}/phan-hoi`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy cảm xúc của tôi
export function layCamXucCuaToi(postId: number) {
  try {
    return axiosApi.get(`${P}/bai-dang/${postId}/phan-hoi/cua-toi`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
